import { html, css, LitElement } from "lit-element";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "./filters/filter-default";

// language=css
const swHeaderFiltersStyle = css`
    .header-filters {
		position: relative;
		background-color: var(--app-white, #fff);
		margin-left: auto;
		padding: 6px 20px;
        min-height: 30px;
		width: calc(100% - 40px);
		border-bottom: 1px solid var(--app-lightgrey);
        --sw-dialog-simple-width: 300px;
        --sw-dialog-simple-modal-top: 40px;
        --sw-dialog-simple-radius: 12px;
        --sw-dialog-simple-modal-left: 0;
        --sw-dialog-simple-background: transparent;
        --sw-dialog-simple-animation-time: 100ms;
	}
`;

export class StofwareHeaderFilters extends LitElement {
    static get properties() {
        return {
            title: String,
            page: String,
            endpoint: String,
            meta: {type: Object}
        };
    }
    static get styles() {
        return [LayoutFlex, swHeaderFiltersStyle]
    }

    constructor() {
        super();
    }


    render() {
        // language=HTML
        return html`
            	<div class="header-filters layout horizontal">
            	    ${this.meta.filter_options && this.meta.filter_options.map(filter_option => {
            	        return html`<sw-filter-default .filterOption="${filter_option}" endpoint="${this.endpoint}"></sw-filter-default>`
            	    })}
                </div>
		`;
    }

}

window.customElements.define("sw-header-filters", StofwareHeaderFilters);
